import { useCallback, useSyncExternalStore } from 'react';
import { useMap } from '@vis.gl/react-google-maps';

/** What `getRenderingType()` says until Google has chosen how to draw the map. */
const UNDECIDED = 'UNINITIALIZED';

/**
 * The map, once Google has decided how to draw it: vector, or raster when the
 * browser cannot give it WebGL. A new map is created undecided, and a camera
 * move made before that is dropped (a `fitBounds` then does nothing), so the
 * camera effects wait for this instead of for `useMap()`.
 */
export function useDecidedMap(): google.maps.Map | null {
  const map = useMap();

  const subscribe = useCallback(
    (notify: () => void): (() => void) => {
      if (map === null) return () => undefined;
      const listener = map.addListener('renderingtype_changed', notify);
      return () => {
        listener.remove();
      };
    },
    [map],
  );
  const decided = useSyncExternalStore(
    subscribe,
    () => map !== null && String(map.getRenderingType()) !== UNDECIDED,
  );

  return decided ? map : null;
}
